//import 'slick-carousel';
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

var Init = function(){
  var $window = $(window);
  var $html = $("html");

  var institutionSwiper = void 0;
  var $institutionContainer = $("main .institution-container");
  var $institutionContent = $institutionContainer.find(".institution-content");
  var $institutionBox = $institutionContainer.find(".institution-box");

  var InstitutionSlideSet = function(){
    if(!$institutionContainer.hasClass("swiper-initialized")){
      $institutionContainer.addClass("swiper");
      $institutionContent.addClass("swiper-wrapper");
      $institutionBox.addClass("swiper-slide");
      institutionSwiper = new Swiper('main .institution-container', {
        spaceBetween: "5%",
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        breakpoints: {
          // when window width is >= 320px
          751: {
            allowTouchMove: false
          },
        }
      });
    }
  };
  var InstitutionSlideDestroy = function(){
    if($institutionContainer.hasClass("swiper-initialized")){
      for(var i = 0; i < institutionSwiper.length; i++){
        institutionSwiper[i].destroy(false,true);
      }
      institutionSwiper = void 0;

      $institutionContainer.removeClass("swiper");
      $institutionContent.removeClass("swiper-wrapper");
      $institutionBox.removeClass("swiper-slide");
    }
  };

  var institutionImageSwiper = void 0;
  var $modalImageContainer = $(".modal .institution-container");
  var $modalImageContent = $modalImageContainer.find(".institution-imgs");
  var $modalImage = $modalImageContainer.find(".institution--img");

  var ModalImagesSlideSet = function(){
    if(!$modalImageContainer.hasClass("swiper-initialized")){
      $modalImageContainer.addClass("swiper");
      $modalImageContent.addClass("swiper-wrapper");
      $modalImage.addClass("swiper-slide");
      institutionImageSwiper = new Swiper('.modal .institution-container', {
        spaceBetween: 0,
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
      });
    }
  };
  var ModalImagesSlideDestroy = function(){
    if($modalImageContainer.hasClass("swiper-initialized")){
      for(var i = 0; i < institutionImageSwiper.length; i++){
        institutionImageSwiper[i].destroy(false,true);
      }
      institutionImageSwiper = void 0;

      $modalImageContainer.removeClass("swiper");
      $modalImageContent.removeClass("swiper-wrapper");
      $modalImage.removeClass("swiper-slide");
    }
  };

  // Resize
  var _isSP;
  var Resize = function(){
    if($window.width() < 751){
      _isSP = true;
      InstitutionSlideSet();
      ModalImagesSlideSet();

    }else{
      _isSP = false;
      InstitutionSlideDestroy();
      ModalImagesSlideDestroy();
    }
  };

  $window.on("resize", Resize);
  Resize();

  // Open-Close
  $("main .institution").removeClass("institution-open");
  var $institutionHead = $("main .institution--head");
  var OpenCloseFunc = function(){
    var _$this = $(this);
    var _$parent = _$this.parent();
    if(_$parent.hasClass("institution-open")){
      _$parent.removeClass("institution-open");
    }else{
      _$parent.addClass("institution-open");
      $("html, body").stop().animate({scrollTop: _$parent.offset().top}, 300);
    }
  };
  $institutionHead.on("click", OpenCloseFunc);

  // MODAL
  var SelectModalOpen = function(event){
    // console.log("SelectModalOpen");
    var _$target = $(event.currentTarget);
    var _parentId = "modal_" + _$target.data("institution");
    var _number = _$target.data("number") - 1;
    var $modal = $("#" + _parentId);
    var $modalWrap = $modal.find(".modal-wrap");
    var $modalOverlay = $modal.find(".modal-overlay");
    var $modalClose = $modal.find(".modal--close, .modal-close");
    $html.addClass("is-modal");
    // console.log("SelectModalOpen");
    $modal.css({zIndex: 1});
    $modalWrap.scrollTop(0);

    modalSwiper = new Swiper("#" + _parentId + ' .modal-content', {
      spaceBetween: "15%",
      slidesPerView: 1,
      initialSlide: _number,
      navigation: {
        nextEl: ".modal--next",
        prevEl: ".modal--prev",
      },
      breakpoints: {
        // when window width is >= 320px
        751: {
          autoHeight: true
        },
      }
    });
    modalSwiper.on('slideChange', function () {
      //$modalWrap.stop().animate({scrollTop: 0}, 300);
      $modalWrap.scrollTop(0);
    });

    $modalOverlay.on("click", SelectModalClose);
    $modalClose.on("click", SelectModalClose);
  };
  var SelectModalClose = function(){
    // console.log("SelectModalClose");
    var $modal = $(".modal");
    var $modalOverlay = $modal.find(".modal-overlay");
    var $modalClose = $modal.find(".modal--close, .modal-close");
    var $modalContents = $modal.find(".modal-content");
    $modal.css({zIndex: ""});
    $html.removeClass("is-modal");
    modalSwiper.destroy(true, true);

    $modalOverlay.off("click", SelectModalClose);
    $modalClose.off("click", SelectModalClose);
  };
  $("body").on("click", ".modal--btn", SelectModalOpen);


  // SLIDER
  var styleSwiper = new Swiper('.style-content', {
    loop: true,
    autoplay: true,
    spaceBetween: 5,
    slidesPerView: 2,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      // when window width is >= 320px
      751: {
        spaceBetween: 12,
        slidesPerView: 4,
      },
    }
  });

  var newsSwiper = new Swiper('.news-content', {
    spaceBetween: "5.5%",
    slidesPerView: 1,
    navigation: {
      nextEl: ".news--next",
      prevEl: ".news--prev",
    },
    breakpoints: {
      // when window width is >= 320px
      751: {
        spaceBetween: 12.5,
        slidesPerView: 3,
      },
    }
  });

  var modalSwiper = void 0;




  // ScrollAnimatiopn
  window.AnimationStart = function($container){
    // console.log("AnimationStart");
    var _$wait = $container.find(".wait");
    _$wait.each(function(){
      var __$this = $(this);
      var __delay = __$this.data("delay");
      var __timeout = setTimeout(function(){
        __$this
          .removeClass("wait")
          .addClass("animation");
        clearTimeout(__timeout);
      }, __delay)
    });

  };

  var ResetAnimate = function($container){
    // console.log("ResetAnimate");
    var _$animate = $container.find(".animation");
    var _$animating = $container.find(".animating");
    _$animate.each(function(){
      var __$this = $(this);
      __$this
        .addClass("wait")
        .removeClass("animation");
    });
    _$animating.each(function(){
      var __$this = $(this);
      __$this
        .addClass("waiting")
        .removeClass("animating");
    });
  };

  var setAnimation = function(){
    // console.log("setAnimation:");
    var $section = $(".waiting");
    var sectionLen = $section.length;
    var timing, _height, mainHeight, mainTop;
    if(_isSP){
      _height = $window.height();
      mainTop = ($window.height() - mainHeight) / 2;
      timing = mainHeight - 100;
    }else{
      _height = $window.height();
      mainTop = 0;
      timing = _height - (_height / 4);
    }

    for(var i = 0; i < sectionLen; i++){
      var $wait = $($section[i]);
      var offsetTop;

      offsetTop = $wait.offset().top;
      if(
        $window.scrollTop() + timing >= offsetTop
      ){
        var _delay = $wait.data("delay");
        if(_delay === void 0){
          _delay = 0;
        }
        $wait.delay(_delay).queue(function(){
          var __$this = $(this);
          __$this.removeClass("waiting").addClass('animating');
          __$this.dequeue();
        });
      }else{
        //
      }
    }
  };

  var AnimationScroller = function(){
    setAnimation();
  };

  $window.on("scroll", AnimationScroller);
  AnimationScroller();

  $(".fix-pagetop a").on("click", function(){
    $("html, body").stop().animate({scrollTop: 0}, 300);
    return false;
  });


};

window.addEventListener("load", Init);